<template>
  <div class="wrapper">
    <Header class="header" :val="headerTitle"></Header>
    <div class="container">
      <!-- content(s) -->
      <div id="content">
        <section>
          <ValidationObserver ref="form">
            <div class="formArea">
              <span class="label">주문번호</span>
              <ValidationProvider name="주문번호" rules="required" v-slot="{ errors }" vid="userId">
                <input type="text" class="ipt id" placeholder="ID1234R12345" title="주문번호 입력" value="" v-model="orderId" />

                <p class="fieldMsg error" id="idMsg" v-if="errors[0]">
                  {{ errors[0] }}
                </p>
              </ValidationProvider>
              <!-- <p class="fieldMsg error" id="idMsg">
                주문번호가 올바르지 않습니다. 다시 확인해주세요.
              </p> -->

              <span class="label">휴대폰번호</span>
              <ValidationProvider name="휴대폰번호" rules="required|cellNum" v-slot="{ errors }" vid="cellNum">
                <input
                  type="tel"
                  id="phone_2"
                  class="ipt"
                  title="휴대폰번호 입력"
                  placeholder="' - ' 없이 입력해주세요."
                  value=""
                  v-model="cellNum"
                />
                <p class="fieldMsg error" id="idMsg2" v-if="errors[0]">
                  {{ errors[0] }}
                </p>
              </ValidationProvider>

              <!-- <p class="fieldMsg error" id="idMsg">
                휴대폰번호가 올바르지 않습니다. 다시 확인해주세요.
              </p> -->
            </div>
            <div class="btnArea mt20">
              <button type="button" class="btn_p" @click="inquery" :disabled="!inputCheck">조회</button>
            </div>
            <ul class="txtList_square txtXS">
              <li>
                주문번호는 주문완료시 계약자 휴대폰번호로 알림톡 발송됩니다.
              </li>
              <li>
                주문번호가 기억나지 않을경우
                <strong>
                  고객센터(
                  <a href="tel:1670-0202">1670-0202</a>
                  )
                </strong>
                로 연락주시기 바랍니다.
              </li>
            </ul>
          </ValidationObserver>
          <div class="btnArea mt60">
            <button type="button" class="btn_s" @click="join">회원가입</button>
          </div>
        </section>
      </div>
      <!-- content(e) -->
    </div>
    <!-- container(e) -->
    <footer class="footer"></footer>
    <MessagePop v-if="messagePop" @close="messagePop = false">
      <p v-html="msg"></p>
    </MessagePop>
  </div>
  <!-- wrapper(e) -->
</template>
<script>
import { INPUT_INFO_CHECK } from '@/store/message.type';
import ApiService from '@/common/api.service';
import MessagePop from '@/components/popup/MessagePop';

export default {
  name: 'guestOrder',
  components: { MessagePop },
  data() {
    return {
      headerTitle: '비회원 주문조회',

      orderId: '',
      cellNum: '',
      messagePop: false,

      inputCheck: false,
    };
  },
  mounted() {
    if (this.orderId != '' && this.cellNum != '') {
      this.inputCheck = true;
    } else {
      this.inputCheck = false;
    }
  },
  watch: {
    orderId() {
      if (this.orderId != '' && this.cellNum != '') {
        this.inputCheck = true;
      } else {
        this.inputCheck = false;
      }
    },
    cellNum() {
      if (this.orderId != '' && this.cellNum != '') {
        this.inputCheck = true;
      } else {
        this.inputCheck = false;
      }
    },
  },
  methods: {
    inquery() {
      this.$refs.form.validate().then(success => {
        if (!success) {
          this.msg = INPUT_INFO_CHECK;
          this.messagePop = true;
        } else {
          ApiService.service('GET', 'order/nonmember/' + this.orderId + '/mobile/' + this.cellNum)
            .then(({ data }) => {
              console.log(data);
              if (data.isSucceed) {
                if (data.result !== '') {
                  this.$router.push({ name: 'guestOrderList', params: { orderId: this.orderId, cellNum: this.cellNum } });
                } else {
                  this.msg = '조회되는 상품이 없습니다.<br/>주문번호를 다시 확인해 주세요.';
                  this.messagePop = true;
                }
              } else {
                this.msg = '조회되는 상품이 없습니다.<br/>주문번호를 다시 확인해 주세요.';
                this.messagePop = true;
              }
            })
            .catch(({ response }) => {
              console.log('error : ' + response);
            });
        }
      });
    },
    join() {
      this.$router.push('/join/joinStep1');
    },
  },
};
</script>
